var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.value,"name":_vm.name,"disabled":_vm.disabled,"items":_vm.items,"label":_vm.label,"error-messages":_vm.errorMessages,"hide-details":_vm.hideDetails,"item-disabled":_vm.itemDisabled},on:{"input":args => _vm.$emit('input', args)}})
}
var staticRenderFns = []

export { render, staticRenderFns }